import React, { useState, useEffect } from 'react';
import { Box, Container, Typography } from '@mui/material';
import axios from 'axios';
import API_BASE from '../apiBase';
import Plans from './Plans';
import { TabNavigation, PaymentHistorySection, PlansSection } from '../components/subscription';
import { trackButtonClick } from '../utils/gtm';

const ManageSubscription = () => {
  const [tabValue, setTabValue] = useState(0);
  const [currentSubscription, setCurrentSubscription] = useState(null);
  const [currentPlan, setCurrentPlan] = useState(null);
  const [paymentHistory, setPaymentHistory] = useState([]);
  const [loading, setLoading] = useState(true);



  useEffect(() => {
    fetchSubscriptionData();
  }, []);

  const fetchSubscriptionData = async () => {
    try {
      setLoading(true);
      
      // Fetch current subscription
      const subscriptionResponse = await axios.get(`${API_BASE}/api/payments/current-subscription`);
      if (subscriptionResponse.data.has_active_subscription) {
        setCurrentSubscription(subscriptionResponse.data.subscription);
        setCurrentPlan(subscriptionResponse.data.plan);
      }

      // Fetch payment history
      const historyResponse = await axios.get(`${API_BASE}/api/payments/history`);
      // Sort by latest first as backup
      const sortedPayments = historyResponse.data.sort((a, b) => 
        new Date(b.created_at) - new Date(a.created_at)
      );
      setPaymentHistory(sortedPayments);
    } catch (error) {
      console.error('Error fetching subscription data:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleTabChange = (newValue) => {
    const tabNames = ['upgrade_plan', 'payments'];
    trackButtonClick(`subscription_tab_${tabNames[newValue]}`, 'manage_subscription_page');
    setTabValue(newValue);
  };

  const renderUpgradePlansTab = () => {
    return (
      <PlansSection hideHeader={true} />
    );
  };

  const renderPaymentsTab = () => {
    return (
      <PaymentHistorySection 
        paymentHistory={paymentHistory} 
        loading={loading} 
      />
    );
  };



  return (
    <Box sx={{ 
      bgcolor: '#f8fafc', 
      minHeight: '100vh', 
      color: '#1a202c', 
      p: { xs: 2, sm: 3, md: 4 } 
    }}>
      {/* Main Content */}
      <Container sx={{ maxWidth: { lg: "1000px", xl: "1200px" } }}>
        {/* Tab Navigation */}
        <TabNavigation activeTab={tabValue} onTabChange={handleTabChange} />
        {/* Tab Content */}
          {tabValue === 0 && renderUpgradePlansTab()}
          {tabValue === 1 && renderPaymentsTab()}
      </Container>
    </Box>
  );
};

export default ManageSubscription; 